module.exports = __webpack_public_path__ + "images/emoji/traffic_light.32a17229786ea265e3ae.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/traffic_light.png
// module id = Ol01
// module chunks = 24